import { mapState, mapGetters } from 'vuex';
import { getGlobalGetGotoLink } from '@utiles/globalGetLink';

export default {
  computed: {
    ...mapState({
      gameId: state => state.gameId,
      showChannel: state => state.showChannel
    }),
    ...mapGetters(['gameInfoConfig']),
    showSwitchVersion() {
      return [191, 285, 263].includes(+this.gameId) && !this.showChannel;
    },
    gameCode() {
      return this.gameInfoConfig?.gameCode;
    }
  },
  methods: {
    switchVersion() {
      window.location.href = getGlobalGetGotoLink({
        link: window.location.href
          .replace('officialStore.html', 'officialTopupNew.html')
          .replace(window.location.hash, '#/')
      });
    }
  }
};
